var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "24306FA6-397A-4723-9B23-320325424711") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M3,0 L3,3 L0,3 L0,0 L3,0 Z M16,0 L16,3 L13,3 L13,0 L16,0 Z M9.5,0 L9.5,3 L6.5,3 L6.5,0 L9.5,0 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,26 L25,26 L25,9 L3,9 L3,26 Z M24.004,3 L22,3 L22,2.30926389e-14 L19,2.30926389e-14 L19,3 L9,3 L9,2.30926389e-14 L6,2.30926389e-14 L6,3 L3.997,3 C1.789,3 0,4.789 0,6.996 L0,25.103 C0,27.31 1.789,29.099 3.997,29.099 L24.004,29.099 C26.211,29.099 28,27.31 28,25.103 L28,6.996 C28,4.789 26.211,3 24.004,3 L24.004,3 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web-Page-Builder-v1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8.0-WebPageBuilder-EmptyWidgets",
    transform: "translate(-67.000000, -336.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WPB-Widgets",
    transform: "translate(0.000000, 128.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Components",
    transform: "translate(24.000000, 200.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(43.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-Builder/Calendar/40dp",
    transform: "translate(1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Purple-Light",
    transform: "translate(12.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#E5E5E5",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Zinier-Colors/Grey",
    mask: "url(#mask-2)",
    fill: "#A5A5A5"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-12.000000, -17.000000)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 64,
    height: 64
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Purple",
    transform: "translate(6.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#E5E5E5",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Zinier-Colors/Grey-Dark",
    mask: "url(#mask-4)",
    fill: "#727272"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6.000000, -5.000000)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarChart);
export default __webpack_public_path__ + "static/media/calendarChart.c32ff2e033489d5aa22f2a545cc160e8.svg";
export { ForwardRef as ReactComponent };